import { Amplify } from 'aws-amplify';

const awsConfig = {
    Auth: {
        Cognito: {
            //  Amazon Cognito User Pool ID
            userPoolId: process.env.REACT_APP_USER_POOL_ID,
            // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
            userPoolClientId: process.env.REACT_APP_USER_POOL_APP_CLIENT_ID,
        },
    },
};

export const initAmplify = () => {
    Amplify.configure(awsConfig);
};
